import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// import throttle from "lodash.throttle";

gsap.registerPlugin(ScrollTrigger);

export default function initGsapScrollState() {
    const body = document.body;

    // // Detect Scroll Milestones
    // ScrollTrigger.create({
    //     trigger: "#app-topbar",
    //     start: "bottom top",
    //     onEnter: () => body.classList.add("HAS-REACHED--STEP-1"),
    //     onLeaveBack: () => body.classList.remove("HAS-REACHED--STEP-1"),
    //     markers: false,
    // });

    ScrollTrigger.create({
        trigger: body,
        start: `${innerHeight} top`,
        toggleClass: "HAS-REACHED--STEP-2",
        markers: false,
    });

    // Sticky Menu State (> 100px)
    ScrollTrigger.create({
        start: 100,
        toggleClass: {
            targets: body,
            className: "STICKY-MENU",
        },
        markers: false,
    });

    ScrollTrigger.create({
        trigger: "#app-footer",
        toggleClass: {
            targets: body,
            className: "HAS-REACHED--FOOTER",
        },
        markers: false,
    });

    // Detect Scroll Direction
    ScrollTrigger.create({
        onUpdate: (self) => {
            body.classList.toggle("SCROLLING--DOWN", self.direction === 1);
            body.classList.toggle("SCROLLING--UP", self.direction === -1);
        },
        markers: false,
    });

    // Detect Scroll Progress
    // ScrollTrigger.create({
    //     onUpdate: throttle(
    //         (self) => {
    //             const scrollProgress = Math.round(self.progress * 100);
    //             document.documentElement.style.setProperty(
    //                 "--SCROLL_PROGRESS",
    //                 `${scrollProgress}`
    //             );
    //         },
    //         100,
    //         { leading: true, trailing: true }
    //     ),
    //     markers: false,
    // });
}
